import { isPending } from "App/apiMiddleware";
import get from "lodash/get";
import { createSelector } from "reselect";
import { NAMESPACE, PAGE_NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
export const getData = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].data`), (data) => data);
export const getInProgress = (state) => isPending(state, actionTypes.GET_PASSWORD_POLICY) ||
    isPending(state, actionTypes.SAVE_PASSWORD_POLICY);
